import { animate, spring } from "motion";
const { disableBodyScroll, enableBodyScroll } = require("body-scroll-lock");

export default class NavOverlay {
  constructor(navbar) {
    this.navbar = navbar;
    this.toggle = $(this.navbar).find(".page-navbar__overlay-toggle")[0];

    this.searchWrapper = $(".search-wrapper")[0];
    this.mainContent = $(".main-content")[0];
    this.pageFooter = $("#target_footer_bottom")[0];

    if (this.toggle) {
      this._init();
    }
  }

  _init() {
    this.$subNavs = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item"
    );
    this.$subNavsLinks = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item > a"
    );
    this.overlay = $(".page-navbar__overlay")[0];
    this.menu = $(".page-navbar__overlay-menu")[0];

    this.toggle.addEventListener("click", this._handelToggleClick.bind(this));
    $(window).on(
      "luther:navbar--uses-overlay",
      this._handleDesktopnavToggle.bind(this)
    );

    // submenus
    this._initSubmenus();
  }

  _handelToggleClick() {
    var isOverlayOpen = this.isOverlayOpen || false;
    if (!isOverlayOpen) {
      this.openOverlay();
    } else {
      this.closeOverlay();
    }
  }

  _handleDesktopnavToggle(showDesktopNav) {
    if (showDesktopNav && this.isOverlayOpen) {
      this.closeOverlay();
    }
  }

  openOverlay() {
    this.isOverlayOpen = true;
    this.overlay.removeAttribute("inert");
    this.overlay.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");
    this.mainContent.setAttribute("inert", "");
    this.pageFooter.setAttribute("inert", "");
    document.body.classList.add("navbar--overlay-is-open");
    disableBodyScroll(this.overlay);
  }

  closeOverlay() {
    this.isOverlayOpen = false;
    this.overlay.setAttribute("inert", "");
    this.overlay.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    this.mainContent.removeAttribute("inert");
    this.pageFooter.removeAttribute("inert");
    document.body.classList.remove("navbar--overlay-is-open");
    enableBodyScroll(this.overlay);
  }

  _initSubmenus() {
    // add html
    $(".menu-item-has-children").prepend(
      '<span class="submenu-toggle chevron right"></span>'
    );
    $(this.overlay)
      .find(".sub-menu")
      .prepend(
        '<li class="menu-item menu-item-back"><span class="chevron left"></span><a>Zurück</a></li>'
      );

    $(this.overlay).find(".sub-menu").wrapInner('<div class="ebene"></div>');

    // event listener
    $(".submenu-toggle").on("click", this._handleSubmenuToggle.bind(this));
    $(".menu-item-back").on("click", this._handleMobileBackButton.bind(this));
  }
  _handleSubmenuToggle(e) {
    var elem = $(e.target);
    elem.toggleClass("in");
    elem.next().next().toggleClass("in");
    elem.closest(".ebene").addClass("out");
    this.overlay.scrollTop = 0;
  }

  _handleMobileBackButton(e) {
    var elem = $(e.target);
    elem.closest(".sub-menu").removeClass("in");
    elem.closest(".ebene.out").removeClass("out");
  }

  resetSubmenus() {
    $(".sub-menu.in").removeClass("in");
    $(".ebene.out").removeClass("out");
  }
}

// _handelNavItemsClick(evt) {
//   evt.preventDefault(evt);
//   const $parentLi = $(evt.currentTarget).closest("li");
//   this._toggleSubMenu($parentLi);
// }

// _toggleSubMenu($parentLi) {
//   if (!$parentLi.hasClass("is-open")) {
//     this._openSubmenu($parentLi);
//   } else {
//     this._hideSubmenu($parentLi);
//   }
//   // close all other submenus
//   $parentLi
//     .closest("ul")
//     .find("li.is-open")
//     .each((i, el) => {
//       if (el === $parentLi[0]) return;
//       this._hideSubmenu($(el));
//     });
// }

// _openSubmenu($parentLi, extra = 0) {
//   const sub = $parentLi.find(".sub-menu").first()[0];
//   if (!sub || !sub.scrollHeight) return;
//   $parentLi.addClass("is-open");
//   const height = `${sub.scrollHeight + extra}px`;
//   animate(
//     sub,
//     { height },
//     { duration: 0.1, easing: spring({ stiffness: 300, damping: 100 }) }
//   );

//   // parent
//   const $parentSubmenuLi = $parentLi
//     .parent()
//     .closest(".menu-item-has-children.is-open");
//   if ($parentSubmenuLi.length) {
//     // add scrollHeight from child
//     this._openSubmenu($parentSubmenuLi, sub.scrollHeight);
//   }
// }

// _hideSubmenu($parentLi, extra = 0) {
//   const sub = $parentLi.find(".sub-menu").first()[0];
//   if (extra === 0) {
//     $parentLi.removeClass("is-open");
//   }
//   const height = extra ? `${sub.clientHeight - extra}px` : 0;
//   animate(sub, { height }, { duration: 0.5 });

//   // parent
//   const $parentSubmenuLi = $parentLi
//     .parent()
//     .closest(".menu-item-has-children.is-open");
//   if ($parentSubmenuLi.length) {
//     const newExta = sub.scrollHeight;
//     this._hideSubmenu($parentSubmenuLi, newExta);
//   }
// }
